import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, ListGroup, ListGroupItem, Button } from 'reactstrap';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import RichTextEditor from '../../../components/RichTextEditor';

//Api
import email_api from '../../../api/email_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Estado inicial do email
function initialStateEmail() {
    return {
        identificacao: "",
        corpo: "",
        finalidade: "",
        assunto: "",
        imagensConteudo: []
    }
}

export default function EditarEmail({ id, loading, setLoading, btnVoltar }) {
    const [email, setEmail] = useState(initialStateEmail());
    const [palavrasComuns, setPalavrasComuns] = useState([]);

    const palavrasChavePorFinalidade = {
        "Análise de PGRS": [
            { chave: "%CNPJGerador%", descricao: "CNPJ do gerador de resíduos" },
            { chave: "%FantasiaGerador%", descricao: "Nome fantasia do gerador" },
            { chave: "%ResultadoAnalise%", descricao: "Resultado da análise (Aprovado/Reprovado)" },
            { chave: "%ObservacoesAnalise%", descricao: "Observações da análise" }
        ],
        "Análise Cadastro Gerador": [
            { chave: "%CNPJGerador%", descricao: "CNPJ do gerador de resíduos" },
            { chave: "%FantasiaGerador%", descricao: "Nome fantasia do gerador" },
            { chave: "%ResultadoAnalise%", descricao: "Resultado da análise (Aprovado/Reprovado)" },
            { chave: "%ObservacoesAnalise%", descricao: "Observações da análise" }
        ],
        "Análise de Cadastro": [
            { chave: "%CNPJGerador%", descricao: "CPF/CNPJ do gerador de resíduos" },
            { chave: "%FantasiaGerador%", descricao: "Nome fantasia do gerador" },
            { chave: "%TipoCadastro%", descricao: "Tipo do cadastro pendente (Gerador ou PGRS)" }
        ],
        "Cancelamento de Contrato": [
            { chave: "%IdentificacaoLocalidade%", descricao: "Identificação da localidade do contrato." },
            { chave: "%IdentificacaoModalidadeColeta%", descricao: "Identificação da modalidade de coleta do contrato." }
        ],
        "Auto de Infração": [
            { chave: "%CPFCNPJ%", descricao: "CPF ou CNPJ do autuado" },
            { chave: "%Fantasia%", descricao: "Nome fantasia do autuado" },
            { chave: "%RazaoSocial%", descricao: "Razão social do autuado" },
            { chave: "%LinkAutoInfracao%", descricao: "Link para acessar o Auto de Infração" }
        ],
        "Notificação": [
            { chave: "%dataNotificacao%", descricao: "Data em que a notificação foi feita" },
            { chave: "%tipoNotificacao%", descricao: "Tipo da notificação realizada" },
            { chave: "%observacao%", descricao: "Observações da notificação" }
        ]
    };


    //Salva os dados do email
    function salvarEmail() {
        setLoading(true);
        email_api.Put(email).then(response => {
            showMessage("Sucesso", "Sucesso ao atualizar o email", "success", btnVoltar);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        })
    }

    async function loadEmail(id) {
        setLoading(true);
        try {
            const response = await email_api.GetItem(id);
            setEmail(response.data);
        } catch (e) {
            showMessage("Aviso", e.message, "error", null);
        } finally {
            setLoading(false);
        }
    }

    function carregarPalavrasComuns() {
        if (!email.finalidade) return;

        const comuns = [];

        if (
            email.finalidade !== "Análise de PGRS" &&
            email.finalidade !== "Análise Cadastro Gerador" &&
            email.finalidade !== "Análise de Cadastro" &&
            email.finalidade !== "Auto de Infração" &&
            email.finalidade !== "Notificação"
        ) {
            comuns.push(
                { chave: "%IdentificacaoCadastro%", descricao: "Identificação do cadastrado" },
                { chave: "%LinkAcesso%", descricao: "Link de acesso para o novo usuário alterar sua senha." }
            );
        }

        if ([
            "Recuperação de Senha",
            "Cadastro Usuário",
            "Cadastro Gerador",
            "Cadastro Transportador",
            "Cadastro Destino"
        ].includes(email.finalidade)) {
            comuns.push({
                chave: "%Senha%",
                descricao: "Senha temporária enviada para o e-mail do usuário."
            });
        }

        setPalavrasComuns(comuns);
    }

    useEffect(() => {
        if (id) {
            loadEmail(id);
        }
    }, [id]);

    useEffect(() => {
        carregarPalavrasComuns();
    }, [email.finalidade]);

    //Função que salva as imagens base64 adicionadas no conteudo html
    const setImage = (base64, e) => {
        const _email = {
            ...email,
            [e.target.name]: e.target.value,
            imagensConteudo: [
                ...email.imagensConteudo ? email.imagensConteudo : [],
                base64
            ]
        };
        setEmail(_email);
    }

    //Change dos dados do email
    const onChangeEmail = (e) => {
        const { name, value } = e.target;
        setEmail({
            ...email,
            [name]: value
        })
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard btnVoltar={btnVoltar}>
                <Row>
                    <Col md="12" lg="12" className='mb-4'>
                        <ListGroup>
                            <ListGroupItem className='text-light bg-dark fw-bold'>Palavras Chaves</ListGroupItem>
                            {[...palavrasComuns, ...(palavrasChavePorFinalidade[email.finalidade] || [])].map((item, index) => (
                                <ListGroupItem key={index}>
                                <span className="fw-bold">{item.chave}</span> - {item.descricao}
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        <TextField maxLength={"100"} label={"Assunto"} name="assunto" value={email.assunto} onChange={onChangeEmail} />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12">
                        {id && email.corpo != "" ? <RichTextEditor saveImage={setImage} name="corpo" value={email.corpo} onChange={onChangeEmail} /> : ""}
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center'>
                        <Button color='warning text-light' className='mt-4 px-3' onClick={salvarEmail}><FontAwesomeIcon className='pe-2' icon={faEdit} /> Editar</Button>
                    </Col>
                </Row>
            </MainCard>
        </>
    )
}
